import React from "react";
import { Link } from "react-router-dom";
import { Sprout, Twitter, Facebook, Instagram, Youtube } from "lucide-react";
import { footerLinks, brand } from "../mock";

const Footer = () => {
  return (
    <footer className="bg-black text-white border-t border-white/10">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 md:py-20">
        <div className="grid grid-cols-2 md:grid-cols-6 gap-10">
          <div className="col-span-2">
            <div className="flex items-center gap-2">
              <span className="inline-flex items-center justify-center w-9 h-9 rounded-lg bg-teal-500 text-black">
                <Sprout className="w-5 h-5" strokeWidth={2.25} />
              </span>
              <span className="text-white font-semibold tracking-tight text-lg">
                {brand.name.split(" ")[0]}
                <span className="text-teal-400"> {brand.name.split(" ")[1]}</span>
              </span>
            </div>
            <p className="mt-4 text-white/55 text-sm max-w-xs leading-relaxed">
              {brand.tagline}
            </p>
            <p className="mt-3 text-teal-300/80 text-xs italic">{brand.verse}</p>
            <div className="mt-6 flex items-center gap-3">
              {[Twitter, Facebook, Instagram, Youtube].map((Icon, i) => (
                <a
                  key={i}
                  href="#"
                  className="w-9 h-9 rounded-full border border-white/15 flex items-center justify-center text-white/60 hover:text-teal-300 hover:border-teal-400/50 transition-colors"
                >
                  <Icon className="w-4 h-4" />
                </a>
              ))}
            </div>
          </div>

          {Object.entries(footerLinks).map(([group, links]) => (
            <div key={group}>
              <div className="text-white font-semibold text-sm">{group}</div>
              <ul className="mt-4 space-y-2.5">
                {links.map((l) => (
                  <li key={l}>
                    <a
                      href="#"
                      className="text-sm text-white/55 hover:text-teal-300 transition-colors"
                    >
                      {l}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div className="text-xs text-white/40">
            © {new Date().getFullYear()} {brand.name} App · Built for people who serve people.
          </div>
          <div className="flex items-center gap-6 text-xs text-white/50">
            <Link to="/privacy" className="hover:text-teal-300">Privacy</Link>
            <Link to="/terms" className="hover:text-teal-300">Terms</Link>
            <Link to="/founders" className="hover:text-teal-300">Founders&apos; Circle</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
